module.exports = __webpack_public_path__ + "static/media/partediaria.da5ef88a.png";